import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';

import { createEffectFactory } from '@recruitee/ngrx';

import { MessagesCountersHttpClient } from './messages-counters-http-client';
import { MessagesCountersActions } from './messages-counters.store';

@Injectable({ providedIn: 'root' })
export class MessagesCountersEffects {
  public effect = createEffectFactory(MessagesCountersActions, this.actions$);

  private fetch$ = this.effect(MessagesCountersActions.fetch, ({ payload }) =>
    this.http.loadMessagesCounters(payload.candidateId),
  );

  constructor(
    private actions$: Actions,
    private http: MessagesCountersHttpClient,
  ) {}
}
